import React from 'react';

export default function SectionHeader({ eyebrow, title, subtitle, align = 'left', tone = 'ink', size = 'lg', children }) {
  const headingColor = tone === 'cream' ? 'text-white' : 'text-[hsl(var(--c-ink))]';
  const eyebrowColor = tone === 'cream' ? 'text-white/80' : 'text-[hsl(var(--c-ink))]/70';
  const subColor = tone === 'cream' ? 'text-white/85' : 'text-[hsl(var(--c-ink-soft))]';
  const sizeCls = size === 'xl' ? 'display-lg' : 'display-md';

  return (
    <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <div className={`eyebrow ${eyebrowColor}`}>{eyebrow}</div>
      )}
      {title && (
        <h2 className={`mt-3 sm:mt-4 font-heading font-extrabold tracking-[-0.02em] leading-[0.96] ${sizeCls} ${headingColor}`}>
          {title}
        </h2>
      )}
      {subtitle && (
        <p className={`mt-4 sm:mt-5 text-base sm:text-lg leading-relaxed ${subColor}`}>
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
}
